<template>
  <div class="wrapper">
    <div class="header">
      <FundNameView :name="fundName" :code="''" :type="'1'"/>
      <div class="tradeStateView">
        <div class="cnnextCode">{{fundCode}}</div>
        <div class="cnStateView" >{{FundVenueInfo.TagMarkTip}}</div>
        <div class="tradeInTime"
        v-if="FundVenueInfo.TagMarkTip === '交易中'">{{FundVenueInfo.TagMarkTime}}</div>
      </div>
      <div class="header-top">
        <div class="left-panel">
          <div class="net-mian-middle">
            <span class="net-value"
            :style="{ color: getValueColor(FundVenueInfo.Change)}">{{FundVenueInfo.Close}}</span>
          </div>
          <div class="net-value-middle" v-if="FundVenueInfo.TagMark !== '停牌'">
            <span class="net-value-sm"
            :style="{ color: getValueColor(FundVenueInfo.Change)}">{{FundVenueInfo.Change}}</span>
            <span class="net-value-sm"
            :style="{ color: getValueColor(FundVenueInfo.Change)}">{{FundVenueInfo.ChangePercent}}
            <span class="market-unit" v-if="FundVenueInfo.ChangePercent !== '--'"
            :style="{ color: getValueColor(FundVenueInfo.Change)}">%</span>
            </span>
          </div>
        </div>
        <div class="top-right">
          <div class="right-panel">
            <div class="nav" v-for="(item, index) in netValmidData" :key="index">
              <div class="market-label" >{{item["label"]}}</div>
              <div class="market-value" v-if="index === 0"
              :style="{ color: getValueColor(item['value'])}">{{item["value"]}}</div>
              <div class="market-value" v-if="index !== 0">{{item["value"]}}</div>
            </div>
          </div>
          <div class="right-panel">
            <div class="nav" v-for="(item, index) in netValrightData" :key="index">
              <div class="market-label">{{item["label"]}}</div>
              <div class="market-value" v-if="index === 1"
              :style="{ color: getValueColor(FundVenueInfo.ZJL)}">{{item["value"]}}</div>
              <div class="market-value" v-if="index !== 1">{{item["value"]}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="header-bottom">
        <div class="market" v-for="(item, index) in marketData" :key="index">
          <span class="market-label float-left">{{item["label"]}}</span>
          <span :class="getFontSize(item)?'market-bvalue':'market-avalue'"
          :style="{ color: getValuezdIndexColor(index, item['value'])}"
          >{{item["value"]}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JS from '@/base/JSTool';
import { formatDate } from '@fund/basic-lib/dist/lib/date';
import StoreManger from '@/utils/FundHQJHManger';
import FundNameView from '@/components/Fund-FundNameVIew.vue';
import { numeral } from '@fund/basic-lib';
import NativeMsg from '@/base/NativeMsg';
import {
  setNavTitle,
  setNavBarScroll,
  getIs50Sys,
} from '@/utils/nativeBridge';

export default {
  name: 'fundHeaderCN',
  props: {},
  watch: {},
  components: {
    FundNameView,
  },
  data() {
    return {
      FundVenueInfo: {},
      netValData: [],
      netValmidData: [],
      netValrightData: [],
      marketData: [],
      fundCode: '',
      fundName: '',
      fundType: '',
      headerClass: '',
      isTs: false,
      showwap: false,
    };
  },
  computed: {},
  created() {
    this.configureFund();
    this.handleDefault();
  },
  methods: {
    render() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.showwap = true;
      }
      // #endif
      this.configureFund();
      this.request();
      const fundinfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(fundinfo);
      const endDate = new Date(fundinfo.TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      if (serverDate > endDate) {
        this.isTs = true;
      }
      this.fundName = name;
      this.handleData(fundinfo, null);
    },
    getValuezdIndexColor(index, value) {
      if (value === '--') {
        return '#000000';
      }
      let cor = '#000000';
      if (index === 2 || index === 5) {
        cor = '#000000';
      } else if (index === 3 || index === 4) {
        cor = '#12b412';
      } else if (index === 0 || index === 1) {
        cor = '#ff0000';
      }
      return cor;
    },
    configureFund() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
    },
    async request() {
      const fundinfo = StoreManger.getFundJJXQ();
      const newmarket = this.getValueStrWithKey(fundinfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${this.fundCode}`;
      // console.log(`zxy fundin ${fundin}`);
      const allinfo = await this.$store.dispatch('updateStokeHQCodelist', fundin);
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      if (allinfo.lt === '2' || allinfo.lt === 2) {
        NativeMsg.post(JSON.stringify({ key: 'cnhwhqshow', value: { state: 1 } }));
      }
      this.handleData(fundinfo, stokeinfo);
      this.configNavDate();
    },
    tradeTimeTip() {
      const fundinfo = StoreManger.getFundJJXQ();
      // 股票判断
      const newmarket = this.getValueStrWithKey(fundinfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${this.fundCode}`;
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      const time = this.getValueStrWithKey(stokeinfo, 'f86');

      // f292 交易状态枚举值（后续可能会继续扩充）：

      // 0：未知状态 (请勿显示)
      // 1：开盘竞价
      // 2：交易中
      // 3：盘中休市
      // 4：收盘竞价
      // 5：已收盘
      // 6：停牌
      // 7：退市
      // 8：暂停上市
      // 9：未上市
      // 10：未开盘
      // 11：盘前 (美股)
      // 12：盘后 (美股)
      // 13：休市
      // 14：盘中停牌
      // 15：非交易代码
      // 16：波动性中断
      // 17：盘后交易启动 (沪深)
      // 18：盘后集中撮合交易 (沪深)
      // 19：盘后固定价格交易 (沪深)
      const tagData = {
        0: '--',
        1: '开盘竞价',
        2: '交易中',
        3: '盘中休市',
        4: '收盘竞价',
        5: '已收盘',
        6: '停牌',
        7: '退市',
        8: '暂停上市',
        9: '未上市',
        10: '未开盘',
        11: '盘前(美股)',
        12: '盘后(美股)',
        13: '休市',
        14: '盘中停牌',
        15: '非交易代码',
        16: '波动性中断',
        17: '盘后交易',
        18: '盘后交易',
        19: '盘后交易',
      };

      if (time && time !== '--') {
        const tradeT = formatDate(new Date(time * 1000), 'MM-dd hh:mm:ss');
        if (tradeT.length > 0) {
          const tag = this.getValueStrWithKey(stokeinfo, 'f292');
          // eslint-disable-next-line no-prototype-builtins
          if (tagData.hasOwnProperty(`${tag}`)) {
            return tagData[`${tag}`];
          }
          return '--';
        }
      }
      return '--';
    },
    tradeDateTime() {
      const fundinfo = StoreManger.getFundJJXQ();
      const newmarket = this.getValueStrWithKey(fundinfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${this.fundCode}`;
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      const time = this.getValueStrWithKey(stokeinfo, 'f86');
      if (time && time !== '--') {
        const tradeT = formatDate(new Date(time * 1000), 'MM-dd hh:mm:ss');
        if (tradeT.length > 0) {
          return tradeT;
        }
      }
      return '--';
    },
    tradeTime() {
      const fundinfo = StoreManger.getFundJJXQ();
      const newmarket = this.getValueStrWithKey(fundinfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${this.fundCode}`;
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      const time = this.getValueStrWithKey(stokeinfo, 'f86');
      if (time && time !== '--') {
        const tradeT = formatDate(new Date(time * 1000), 'MM-dd hh:mm:ss');
        if (tradeT.length > 0) {
          const tag = this.getValueStrWithKey(stokeinfo, 'f292');
          if (tag === '1') {
            return '开盘集合竞价';
          }
          if (tag === '2') {
            return `交易中 ${tradeT}`;
          }
          if (tag === '3') {
            return '盘中休息';
          }
          if (tag === '4') {
            return '集合竞价';
          }
          if (tag === '5') {
            return '收盘';
          }
          return '停牌';
        }
      }
      return '停牌';
    },
    getCNUpTitleData() {
      const fundinfo = StoreManger.getFundJJXQ();
      const newmarket = this.getValueStrWithKey(fundinfo, 'NEWTEXCH');
      const fundin = `${newmarket}.${this.fundCode}`;
      const stokeinfo = this.$store.state.stokeinfo.fund[fundin];
      const Close = this.getValueStrWithKey(stokeinfo, 'f43');
      let Change = this.getValueStrWithKey(stokeinfo, 'f169');
      if (Change === '0') {
        Change = parseFloat(Change).toFixed(3);
      }
      let ChangePercent = this.getValueStrWithKey(stokeinfo, 'f170');
      if (ChangePercent === '0') {
        ChangePercent = parseFloat(ChangePercent).toFixed(2);
      }
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        FCODE, SHORTNAME,
      } = baseInfo;
      let cor = '#000000';
      if (parseFloat(ChangePercent) === 0) {
        cor = '#000000';
      } else if (parseFloat(ChangePercent) < 0) {
        cor = '#1BC07C';
      } else if (parseFloat(ChangePercent) > 0) {
        cor = '#ff0000';
      }
      if (ChangePercent !== '--') {
        ChangePercent = `${parseFloat(ChangePercent).toFixed(2)}%`;
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${Close} ${Change} ${ChangePercent}`,
        fundCode: FCODE,
        scrollType: 'down',
        subTitleColor: cor,
      };
      return navData;
    },
    getCNDownTitleData() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        FCODE, SHORTNAME,
      } = baseInfo;
      let fc = FCODE;
      if (!fc) {
        fc = '--';
      }
      const navData = {
        title: SHORTNAME,
        subTitle: `${fc}`,
        fundCode: fc,
        scrollType: 'up',
        subTitleColor: '#000000',
      };
      return navData;
    },
    pageUpShow() {
      if (getIs50Sys()) {
        return;
      }
      const item = this.getCNUpTitleData();
      const upItem = item;
      upItem.scrollType = 'up';
      // 超过100px
      setNavBarScroll(upItem).then(() => {
      }).catch(() => {
      });
    },
    pageDownShow() {
      if (getIs50Sys()) {
        return;
      }
      const item = this.getCNDownTitleData();
      const upItem = item;
      upItem.scrollType = 'down';
      // 超过100px
      setNavBarScroll(upItem).then(() => {
      }).catch(() => {
      });
    },
    configNavDate() {
      const baseInfo = StoreManger.getFundJJXQ();
      const {
        SHORTNAME,
      } = baseInfo;
      document.title = SHORTNAME;
      if (getIs50Sys()) {
        return;
      }
      setNavTitle(this.getCNUpTitleData()).then(() => {
      }).catch(() => {
      });
      setNavTitle(this.getCNDownTitleData()).then(() => {
      }).catch(() => {
      });
    },
    handleDefault() {
      this.handleData(null, null);
    },
    handleData(item, stoke) {
      this.FundVenueInfo = this.format(item, stoke);
      this.formatNetList(this.FundVenueInfo);
      this.formatMarketList(this.FundVenueInfo);
      this.handleClass();
    },
    getZjL(stoke) {
      const baseInfo = StoreManger.getFundJJXQ();
      const Close = this.getValueStrWithKey(stoke, 'f43');
      const dwjz = this.getValueStrWithKey(baseInfo, 'DWJZ');
      if (!Close) {
        return '--';
      }
      if (!dwjz) {
        return '--';
      }
      if (dwjz === '--') {
        return '--';
      }
      if (Close === '--') {
        return '--';
      }
      if (parseFloat(dwjz) === 0) {
        return '--';
      }
      const ZJL = ((parseFloat(dwjz) - parseFloat(Close)) / parseFloat(dwjz)) * 100;
      return `${parseFloat(ZJL).toFixed(2)}`;
    },
    format(item, stoke) {
      let Close = this.getValueStrWithKey(stoke, 'f43');
      if (Close !== '--') {
        Close = numeral(Close).format('0[.]000');
      }

      let Change = this.getValueStrWithKey(stoke, 'f169');
      if (Change !== '--') {
        Change = numeral(Change).format('0[.]000');
      }
      if (Change === '0') {
        Change = '0.000';
      }
      let ChangePercent = this.getValueStrWithKey(stoke, 'f170');
      if (ChangePercent !== '--') {
        ChangePercent = numeral(ChangePercent).format('0[.]00');
      }
      if (ChangePercent === '0') {
        ChangePercent = '0.00';
      }
      const TagMark = this.tradeTime();
      const TagMarkTip = this.tradeTimeTip();
      const TagMarkTime = this.tradeDateTime();
      const Open = this.getValueStrWithKey(stoke, 'f46');
      const Low = this.getValueStrWithKey(stoke, 'f45');
      const High = this.getValueStrWithKey(stoke, 'f44');
      const VolumeSub = this.getValueStrWithKey(stoke, 'f47');
      const AmountSub = this.getValueStrWithKey(stoke, 'f48');
      const RaisePrice = this.getValueStrWithKey(stoke, 'f51');
      const FallPrice = this.getValueStrWithKey(stoke, 'f52');
      const ZJL = this.getZjL(stoke);
      const DWJZ = this.getValueStrWithKey(item, 'DWJZ');
      const TSRQ = this.getValueStrWithKey(item, 'TSRQ');
      const PreviousClose = this.getValueStrWithKey(stoke, 'f60');
      const LastUpdate = this.getValueStrWithKey(stoke, 'f86');
      return {
        TSRQ,
        Close,
        Change,
        ChangePercent,
        TagMark,
        Open,
        Low,
        High,
        VolumeSub,
        AmountSub,
        RaisePrice,
        FallPrice,
        ZJL,
        DWJZ,
        PreviousClose,
        LastUpdate,
        TagMarkTip,
        TagMarkTime,
      };
    },
    getValueColor(value) {
      if (!value) {
        return '#000000';
      }
      if (value === '-') {
        return '#000000';
      }
      if (value === '--') {
        return '#000000';
      }
      if (value > 0) {
        return '#ff0000';
      }
      if (value < 0) {
        return '#12B412';
      }
      return '#000000';
    },
    formatNetList(item) {
      let ZJL = this.getValueStrWithKey(item, 'ZJL');
      if (ZJL !== '--') {
        ZJL = `${numeral(ZJL).format('0.00')}%`;
      }
      let ZS = this.getValueStrWithKey(item, 'PreviousClose');
      if (ZS !== '--') {
        ZS = `${numeral(ZS).format('0.000')}`;
      }
      let JK = this.getValueStrWithKey(item, 'Open');
      if (JK !== '--') {
        JK = `${numeral(JK).format('0.000')}`;
      }
      this.netValmidData = [{
        label: '今开',
        value: JK,
      }, {
        label: '昨收',
        value: ZS,
      }];
      this.netValrightData = [{
        label: '净值',
        value: item.DWJZ,
      }, {
        label: '折价率',
        value: ZJL,
      }];
    },
    formatMarketList(item) {
      let cjl = '--';
      if (item.VolumeSub !== '--') {
        cjl = `${numeral(item.VolumeSub).format('0.00A')}手`;
      }
      let cje = '--';
      if (item.AmountSub !== '--') {
        cje = numeral(item.AmountSub).format('0.00A');
      }
      let zdj = numeral(item.RaisePrice).format('0[.]000');
      let dtj = numeral(item.FallPrice).format('0[.]000');
      const zg = numeral(item.High).format('0[.]000');
      const zd = numeral(item.Low).format('0[.]000');
      if (!zdj) {
        zdj = '--';
      }
      if (!dtj) {
        dtj = '--';
      }
      this.marketData = [{
        label: '最高',
        value: zg,
      }, {
        label: '涨停价',
        value: zdj,
      }, {
        label: '成交量',
        value: cjl,
      }, {
        label: '最低',
        value: zd,
      }, {
        label: '跌停价',
        value: dtj,
      }, {
        label: '成交额',
        value: `${cje}`,
      }];
    },
    getValueStrWithKey(item, key) {
      const res = JS.fetchString(item, key);
      if (res === '-') {
        return '--';
      }
      return res || '--';
    },
    handleClass() {
      const Change = this.FundVenueInfo.Change * 1;
      const tag = this.tradeTime();
      if (tag === '停牌') {
        this.headerClass = 'header-grey';
        return;
      }
      if (Change > 0) {
        this.headerClass = 'header-red';
        return;
      }
      if (Change < 0) {
        this.headerClass = 'header-green';
        return;
      }
      this.headerClass = 'header-white';
    },
    getFontSize(item) {
      if (!item.value) {
        return true;
      }
      if (item.value.length > 6) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper{
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}
.header {

  border-radius: 10px;
  position: relative;
  padding-left: 24px;
  padding-right: 10px;
  padding-bottom: 10px;
  background: #ffffff;
  color: #000;
}

.tradeStateView{
  margin-top: 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.tradeInTime{
  color: #666666;
  margin-left: 10px;
  font-size: 26px;
}
.cnStateView
{
  margin-right: 8px;
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 20px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  color: #666666;
  background: rgba(102, 102, 102, 0.1);
}
.header-top {
  display: flex;
  flex-direction: row;
  padding-top: 30px;
  padding-bottom: 10px;
}

.left-panel {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 32.5%;
}
.top-right {
  display: flex;
  flex-direction: row;
  width: 67.5%;
}
.right-panel {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 48%;
}

.nav {
  display: flex;
  flex-direction: row;
  margin-right: 40px;
  margin-top: 16px;
}
.net-value {
  font-family: DINAlternate-Bold;
  font-size: 58px;
  color: #000;
}

.nav-label {
  margin-bottom: 16px;
}

.net-value-sm {
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000;
  padding-right: 15px;
}
.market-label {
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
  margin-right: 4px;
  white-space:nowrap
}

.market-value {
  display: flex;
  font-family: DINAlternate-Bold;
  font-size: 26px;
  line-height: 24px;
  white-space:nowrap
}
.net-mian-middle {
  display: flex;
  margin-top: 10px;
}

.net-value-middle {
  display: flex;
  margin-top: 5px;
  white-space:nowrap;
}

.desc-text {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #ffffff;
}

.header-bottom {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 25px;
  padding-bottom: 8px;
}

.market {
  width: 30%;
  margin-bottom: 20px;
}

.market:nth-of-type(3n) {
  width: 36%;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.market-unit {
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000;
}
.market-bvalue {
  display: flex;
  font-family: DINAlternate-Bold;
  max-width: 60%;
  font-size: 26px;
  line-height: 26px;
  float: left;
}
.market-avalue {
  display: flex;
  font-family: DINAlternate-Bold;
  max-width: 60%;
  font-size: 18px;
  line-height: 26px;
  float: left;
}
.stop-sale{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 2px solid #eee;
  background: #999999;
  margin-bottom: 15px;
}
.stop-sale-label{
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 36px;
  color: #fff;
}
.cnnextCode{
  color: #999999;
  font-size: 26px;
  margin-right: 8px;
}
</style>
